module.exports = __webpack_public_path__ + "static/img/font-aria@t.59fae61.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/font-aria@t.png
// module id = VTxm
// module chunks = 0